'use client';

import { LazyLottie } from '../LazyLottie';
import { IAnimationProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation for showing biometrics fingerprint unlock animation.
 */
export function BiometricsFingerprintUnlockAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import(
      '../raw-json/functional-assessment/biometrics-fingerprint-unlock.json'
    );

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="BiometricsFingerprintUnlockAnimation"
    />
  );
}
